export default {"src":"/login-app/[GIT_HASH]/_next/static/media/re_execute.54b65444.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};